<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row">
        <div class="col">
          <h1>Administration Tools</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-xs col-lg-3">
          <ul class="nav nav-pills flex-column">
            <li class="nav-item" v-for="link in links" :key="link.href">
              <router-link :to="link.href" v-slot="{ href, isActive, navigate }">
                <a class="nav-link" :class="isActive ? 'active' : ''" :href="href" @click="navigate">{{ link.text }}</a>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-xs col-lg-9">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/views/reports/NavBar.vue";

export default {
  components: {
    NavBar,
  },
  computed: {
    ...mapGetters("role", ["isVerensicsAdministrator"]),
    links() {
      var links = [];

      if (this.isVerensicsAdministrator) {
        links.push({ text: "Report Scores", href: `/admin/recalculate` });
        links.push({ text: "SPSS Excel", href: `/admin/spss` });
        links.push({ text: "User Export", href: `/admin/user-export` });
        links.push({ text: "Report Details Export", href: `/admin/report-details-export` });
        links.push({ text: "Failed Emails", href: `/admin/failed-emails` });
      }

      return links;
    },
  },
};
</script>
